module.exports = __webpack_public_path__ + "img/evaadmin.736730a6.jpg";